module.exports = __webpack_public_path__ + "static/ceo-ced1627a6aa08cfb38f45223d0bdad2e.jpg";